import { render, staticRenderFns } from "./metamask.vue?vue&type=template&id=01499c9a&scoped=true&"
import script from "./metamask.vue?vue&type=script&lang=ts&"
export * from "./metamask.vue?vue&type=script&lang=ts&"
import style0 from "./metamask.vue?vue&type=style&index=0&id=01499c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01499c9a",
  null
  
)

export default component.exports